"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkillExpertiseEnum = void 0;
var SkillExpertiseEnum = {
  beginner: 'BEGINNER',
  intermediate: 'INTERMEDIATE',
  expert: 'EXPERT'
};
exports.SkillExpertiseEnum = SkillExpertiseEnum;